<div
  class="canvas-control-panel"
  *ngIf="attributeState$ | async as attributeState"
>
  <ng-container *ngIf="displayFilter('text-shape') | async">
    <div class="delimiter"></div>
    <div>
      <nw-font-family-selector
        [fontFamily]="attributeState.value.fontFamily?.[0]"
      ></nw-font-family-selector>
    </div>
  </ng-container>

  <ng-container
    *ngIf="containerShapeDescriptor$ | async as containerShapeDescriptor"
  >
    <nw-icon
      *ngIf="containerShapeDescriptor.topology == 'row'"
      (click)="flipTopology(containerShapeDescriptor.topology)"
      type="splitscreen"
      [rotate]="90"
    ></nw-icon>
    <nw-icon
      *ngIf="containerShapeDescriptor.topology == 'column'"
      (click)="flipTopology(containerShapeDescriptor.topology)"
      type="splitscreen"
    ></nw-icon>
  </ng-container>
  <!-- <div *ngIf="displayFilter(undefined, 'container-shape') | async">
    <nw-icon
      (click)="flipTopology(attributeState.value?.topology?.[0])"
      type="splitscreen"
      [rotate]="attributeState.value?.topology?.[0] == 'row' ? 90 : 0"
    ></nw-icon>
  </div> -->

  <ng-container
    *ngIf="
      displayFilter(
        'text-shape',
        'rectangle-shape',
        'circle-shape',
        'glow-shape'
      ) | async
    "
  >
    <div class="delimiter"></div>
    <nw-fill-color-selector
      [color]="(fillAttributeState$ | async).value?.color?.[0]"
    ></nw-fill-color-selector>
  </ng-container>

  <ng-container
    *ngIf="
      (displayFilter('text-shape') | async) &&
      showFontWeightSelector(attributeState.value.fontFamily?.[0])
    "
  >
    <div class="delimiter"></div>
    <nw-font-weight-selector
      [fontWeight]="attributeState.value.fontWeight?.[0]"
      [fontFamily]="attributeState.value.fontFamily?.[0]"
    ></nw-font-weight-selector>
  </ng-container>

  <ng-container *ngIf="displayFilter('text-shape') | async">
    <div class="delimiter"></div>
    <nw-font-align-selector
      [fontFamily]="attributeState.value.align?.[0]"
    ></nw-font-align-selector>
    <div class="delimiter"></div>
    <nw-line-height-selector
      [lineHeight]="attributeState.value.lineHeight?.[0]"
    ></nw-line-height-selector>
  </ng-container>

  <ng-container
    *ngIf="
      displayFilter('rectangle-shape', 'circle-shape', 'path-shape') | async
    "
  >
    <div class="delimiter"></div>
    <nw-stroke-selector
      [state]="strokeAttributeState$ | async"
    ></nw-stroke-selector>
  </ng-container>
</div>
